interface MessageContainer {
  message: string;
  isError?: boolean;
}

const MessageContainer = ({ message, isError = false }: MessageContainer) => {
  return (
    <div className={`center-outside-div ${isError ? "text-danger" : ""}`}>
      {message}
    </div>
  );
};

export default MessageContainer;
